import { defineMessages, type IntlShape } from 'react-intl';
import type { JSONSchema, BlockConfigBase, BlocksFormData } from '@plone/types';
import { addCtaFieldset, type CtaBlockExtender } from '../extenders/cta';
import addBlocksFullWidth from '../extenders/addBlocksFullWidth';
import { showSlideIcon } from '../extenders/carousel/showSlideIcon';
import addBlocksBg from '../extenders/addBlocksBg';
import addBlockLines from '../extenders/addBlockLines';

export interface BowlingCenterCarouselData
  extends CtaBlockExtender,
    JSONSchema {
  '@type': 'bowlingcentercarousel';
  styles: { fullwidth: boolean };
  slides_to_show: number;
  space_between: number;
}

export const BowlingCenterCarouselSchema = ({
  data,
  intl,
}: {
  data: BowlingCenterCarouselData;
  intl: IntlShape;
}): JSONSchema => {
  const schema = {
    title: intl.formatMessage(messages.bowling_center_carousel_title),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['title', 'slides_to_show', 'space_between'],
      },
    ],
    properties: {
      title: {
        title: intl.formatMessage(messages.Title),
      },
      slides_to_show: {
        title: intl.formatMessage(messages.slides_to_show),
        type: 'number',
        default: 3,
      },
      space_between: {
        title: intl.formatMessage(messages.space_between),
        type: 'number',
        default: 100,
      },
    },
    required: [],
  };
  addBlocksFullWidth({ schema, formData: data, intl });
  showSlideIcon({
    schema,
    intl,
    formData: data,
    fieldsetName: 'default',
    beforeField: 'slides_to_show',
  });
  addCtaFieldset({ schema, intl });
  addBlocksBg({ schema, formData: data, intl });
  addBlockLines({ schema, formData: data, intl });

  return schema;
};

export interface BowlingCenterCarouselConfig
  extends Omit<BlockConfigBase, 'blockSchema'> {
  blockSchema: typeof BowlingCenterCarouselSchema;
}

const messages = defineMessages({
  bowling_center_carousel_title: {
    id: 'bowling_center_carousel_title',
    defaultMessage: 'Bowling Center Carousel',
  },
  Title: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  slides_to_show: {
    id: 'slides_to_show',
    defaultMessage: 'Number of slides to show',
  },
  space_between: {
    id: 'space_between',
    defaultMessage: 'Space inbetween slides (in px)',
  },
});
